import React from "react";
import { useAuth } from "../context/AuthContext";
import MinePlannerDashboard from "./rail/MinePlannerDashboard";
import TransnetYardDashboard from "./rail/TransnetYardDashboard";
import GrindrodCoordinatorDashboard from "./rail/GrindrodCoordinatorDashboard";
import OverviewDashboard from "./rail/OverviewDashboard";

/* Role router — picks the correct role-specific rail dashboard.
 * Admin & manager see the Overview by default. */
export default function RailOperationsDashboard() {
    const { user } = useAuth();
    const role = user?.role;
    if (role === "mine_rail_planner") return <MinePlannerDashboard />;
    if (role === "tfr_yard")          return <TransnetYardDashboard />;
    if (role === "rail_coordinator")  return <GrindrodCoordinatorDashboard />;
    return <OverviewDashboard />;
}
